module.exports = __webpack_public_path__ + "static/img/jerryyoon.50581803.jpg";